const handleParse = (message, actionProvider) => {
  const trimmed = message.trim();

  if (trimmed === "") {
    // Prevent action if message is empty

  } else {
    return actionProvider.handleUserMessage(trimmed);
  }
};

class MessageParser {
  constructor(actionProvider) {
    this.actionProvider = actionProvider;
  }

  parse(message) {
    handleParse(message, this.actionProvider);
  }
}

export default MessageParser;
